import React from 'react';
import FormCheckBox from './FormCheckBox';

const valueCardGroup = props => {
  const {
    selectedValues, possibleValues, name, readOnly
  } = props;

  return Array.from(possibleValues)
    .filter(([key]) => !readOnly || (readOnly && selectedValues.has(key)))
    .map(([key, value]) => (
      <FormCheckBox
        name={name}
        text={value}
        key={key}
        value={key}
        checked={readOnly ? false : selectedValues.has(key)}
      />));
};

export default valueCardGroup;



// WEBPACK FOOTER //
// ./src/pages/Helpers/Form/CheckboxValues.js